/**
 * Shared date formatting for the /blog surfaces (index hero, guide cards,
 * article header). One implementation so the meta row reads identically
 * everywhere. Pure, no side effects.
 */

/** Format an ISO date (YYYY-MM-DD) as e.g. "Jun 27, 2026". Safe on bad input. */
export const formatGuideDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};
